import { useEffect, useState } from "react";
import { siteData } from "@/store/siteData";

export default function HeroSection() {
  const [visible, setVisible] = useState(false);
  const hero = siteData.getHero();

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section data-edit="hero" className="relative w-full min-h-[70vh] flex flex-col">
      <div className="absolute inset-0">
        <img
          src="/hero-bg.jpg"
          alt="C2TEK Kurumsal Bilişim Çözümleri"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0F172A]/85 via-[#1E3A8A]/55 to-transparent"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A]/25 via-transparent to-transparent"></div>
      </div>

      <div className="relative z-10 flex-1 flex items-center">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 w-full pt-28 pb-12">
          <div className={`max-w-2xl transition-all duration-1000 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="flex items-center gap-3 mb-6">
              <div className="h-px w-12 bg-[#3B82F6]"></div>
              <span className="text-[#B8C5D8] text-xs font-semibold tracking-[0.3em] uppercase">{hero.tagline}</span>
            </div>
            <h1 className="text-white font-normal mb-6"
              style={{ fontSize: "clamp(24px, 3.4vw, 44px)", letterSpacing: "-0.01em", lineHeight: "1.2" }}
            >
              {hero.title}
            </h1>
            <p className="text-[#9DAEC7] text-base md:text-lg leading-relaxed mb-8 max-w-lg">{hero.subtitle}</p>
            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={() => { const el = document.getElementById("cozumler"); if (el) el.scrollIntoView({ behavior: "smooth" }); }}
                className="whitespace-nowrap inline-flex items-center gap-2 bg-white text-[#111928] px-8 py-4 text-sm font-bold tracking-widest uppercase hover:bg-[#B8C5D8] transition-colors duration-300 cursor-pointer"
              >
                {hero.cta1Text}
                <div className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line text-base"></i></div>
              </button>
              <button
                onClick={() => { const el = document.getElementById("iletisim"); if (el) el.scrollIntoView({ behavior: "smooth" }); }}
                className="whitespace-nowrap inline-flex items-center gap-2 border border-[#3B82F6] text-[#B8C5D8] px-8 py-4 text-sm font-bold tracking-widest uppercase hover:border-[#7B8FAF] hover:text-white transition-all duration-300 cursor-pointer"
              >
                {hero.cta2Text}
              </button>
            </div>
          </div>
        </div>
      </div>

    </section>
  );
}
